import ContentBlock from "../components/ContentBlock";
import HtmlContainer from "../components/HtmlContainer";
import PropTypes from "prop-types";
import React from "react";
import TextSection from "../components/TextSection";
import injectSheet from "react-jss";

const styles = () => ({
  page: {
    height: "100%",
    width: "100%"
  },
  container: {
    width: "100%",
    paddingBottom: "2rem"
  },
  text: {
    paddingLeft: "5rem",
    paddingRight: "5rem",
    "@media (max-width: 823px)": {
      padding: 0,
      marginLeft: "1rem",
      marginRight: "1rem",
      width: "90%"
    },
    "& h1": {
      fontSize: "4.5rem",
      fontWeight: 200,
      margin: 0,
      "@media (max-width: 823px)": {
        fontSize: "3rem",
        textAlign: "center"
      }
    },
    "& h4": {
      fontWeight: 400,
      "@media (max-width: 823px)": {
        fontSize: "1.5rem"
      }
    }
  }
});

const FaqPage = ({ data, classes }) => (
  <ContentBlock className={classes.page}>
    <div className={classes.container}>
      <TextSection className={classes.text}>
        <HtmlContainer content={data.MainContent.html} />
      </TextSection>
    </div>
  </ContentBlock>
);

FaqPage.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.object
};

export default injectSheet(styles)(FaqPage);

/* global graphql */
export const FaqQuery = graphql`
  query FaqQuery {
    MainContent: markdownRemark(frontmatter: { name: { eq: "FAQ" } }) {
      html
      frontmatter {
        name
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/faq.jsx